module.exports = __webpack_public_path__ + "media/map/FL_Icon-420e075d.png";